module.exports = __webpack_public_path__ + "img/radio.11af960a.png";